export default async ({ app }) => {
  app.config.errorHandler = (e) => {
    console.error(e)
  }
}
